import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignersSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { ISignerState } from '../store/completeChart.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setSignChartAs() {
  const signerState: ISignerState = yield select(getSignersSelector)
  const { signChartAs, signer, signerList } = signerState
  const selectedSignChart = signerList.filter((u) => u.key === signer?.key)
  if (selectedSignChart && selectedSignChart.length) {
    selectedSignChart[0].signChartAs = signChartAs
    yield put(setSignerList(signerList))
  }
}
export function* setSignChartAsSaga() {
  yield takeLatest([CompleteChartConstants.SET_SIGN_CHART_AS], performWithMutexHOG, setSignChartAs)
}
